<child-header [title]="data.title" (closeEvent)="onNoClick()"></child-header>

<div mat-dialog-content>

  <mat-spinner
    *ngIf="inProgress"
    mode="indeterminate"
    class="circle"
    diameter="40">
  </mat-spinner>
  <p *ngIf="!inProgress" style="white-space: pre-line">{{ msg }}</p>

</div>
<div class="nce-dialog-action">
  <button
    mat-button
    class="button button-red button-large nce-large-button continue"
    (click)="onContinueEvent()"
  >
    {{ result ? 'OK' : 'Continue' }}
  </button>
</div>
